import { IPagination2, ISorting } from "../../interfaces/Components/ITable";

export interface PageState {
  pagination?: IPagination2;
  sort?: ISorting;
  filter?: Record<string, any>;
  inputFilters?: any;
  scrollPosition?: number;
  selectedTab?: number;
}

export interface PagePersistingState {
  [key: string]: PageState;
}

export interface ISetPageState {
  pathname: string;
  pageState?: PageState
  scrollPosition?: number;
}

export const initialState: PagePersistingState = {};
